import * as React from "react";

const SvgBack = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.6667 9.16667H6.525L11.1833 4.50834L10 3.33334L3.33334 10L10 16.6667L11.175 15.4917L6.525 10.8333H16.6667V9.16667Z" fill="currentColor" /></svg>;

export default SvgBack;